module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/madison-beach-292180740a7597f68ed0f1cdd9dfb63f.jpg";